import currentUserStore from 'stores/CurrentUserStore';

export const requirements = {
  flipFlopRequirements: ['unify-beta'],
};

export const verifier = () => {
  const { userStore = {} } = currentUserStore;
  const janusUser = userStore.loggedInToJanus;
  return userStore.unifyActive && janusUser;
};
